
import React from "react";
import "./Projects.scss";
import { MdWork } from "react-icons/md";
import Rentora from "../../Static/Images/Rentora.jpg";
import Needo from "../../Static/Images/Needo.jpg";

function Projects() {
  const works = [
    {
      title: "Rentora",
      image: Rentora,
      desc: "Rentora - Car Rental Management Platform",
      live: "https://rentora-cars-jd2r.vercel.app/",
      github: "https://github.com/prasadmagdum/rentora",
    },
    {
      title: "Needo",
      image: Needo,
      desc:
        "A donation platform connecting donors with NGOs and people in need.",
      live: "https://needo-helping-those-in-need.netlify.app/",
      github:
        "https://github.com/prasadmagdum/Needo-Helping-Those-in-Need.git",
    },
    {
      title: "CareerAI",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQFQmK03r-71R9_lBh-cgH14l79MV5VgSOHyzH4Z_DXLvoDIMqffu_ycoFW&s=10",
      desc:
        "An AI-powered career platform featuring intelligent resume analysis, job matching, and interview preparation.",
      github:
        "https://github.com/prasadmagdum/CareerAI-Intelligent-Resume-Analyzer-Job-Matching-Platform-.git",
    },
    {
      title: "Milk Products Website",
      image:
        "https://themewagon.com/wp-content/uploads/2022/10/milky.png",
      desc:
        "A dairy products website showcasing milk and dairy products with a clean, user-friendly UI.",
      github:
        "https://github.com/prasadmagdum/Milk-Products-site.git",
    },
  ];

  return (
    <div className="page-container">
      <div className="page-icon">
        <MdWork />
      </div>

      <div className="projects-container">
        {works.map((work) => (
          <div className="card" key={work.title}>
            <img
              src={work.image}
              alt={work.title}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />

            <div className="overlay">
              <h3>{work.title}</h3>
              <p>{work.desc}</p>

              <div className="project-links">
                {work.live && (
                  <a
                    href={work.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                  >
                    Live Demo
                  </a>
                )}

                <a
                  href={work.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn secondary"
                >
                  GitHub
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
